import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { NavTabModel } from '@cas/components/tabs/nav-tab/NavTab';
import NavTabs from '@cas/components/tabs/nav-tabs/NavTabs';
import SubTabsPage from '@customer/templates/sub-tabs-page/SubTabsPage';

export function SingleAssetInteractions() {
  const { t } = useTranslation();

  const { assetId } = useParams();

  const tabs = useMemo<NavTabModel[]>(() => {
    return assetId
      ? [
          {
            title: t('VehicleInteractions'),
            to: `/asset/${assetId}/interactions/vehicle-interactions`,
          },
          {
            title: t('GeofenceInteractions'),
            to: `/asset/${assetId}/interactions/geofence-interactions`,
          },
        ]
      : [];
  }, [t, assetId]);

  return (
    <SubTabsPage tabs={<NavTabs tabs={tabs} />}>
      <Outlet />
    </SubTabsPage>
  );
}

export default SingleAssetInteractions;
